import React, { FunctionComponent } from "react";
import styles from "./ModalCancelButton.module.scss";

interface ModalCancelButtonInterface {
  getConfirmation: ()=> void
}

export const ModalCancelButton: FunctionComponent<ModalCancelButtonInterface> = ({getConfirmation, children}) => {
  return <a className={styles.delete} onClick={getConfirmation}>{children}</a>
}